import React, { useState, useEffect } from "react";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
} from "@mui/material";
import TimeInput from "./TimeInput";

function EditRowDialog({ table, row, initialData, handleUpdateOrder }) {
  const initialTotalSeconds = initialData.proc_time || 0;
  const initialHours = Math.floor(initialTotalSeconds / 3600)
    .toString()
    .padStart(2, "0");
  const initialMinutes = Math.floor((initialTotalSeconds % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const initialSeconds = (initialTotalSeconds % 60).toString().padStart(2, "0");
  const [time, setTime] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds,
  });
  const [values, setValues] = useState({
    ...initialData,
    proc_name: initialData.proc_name || "",
    batch_size: initialData.batch_size || 1,
    uph: initialData.uph || 0,
    proc_time: initialTotalSeconds,
  });
  const [lastUpdated, setLastUpdated] = useState(null);
  const calculateTotalSeconds = () => {
    return (
      Number(time.hours || 0) * 3600 +
      Number(time.minutes || 0) * 60 +
      Number(time.seconds || 0)
    );
  };
  useEffect(() => {
    if (lastUpdated !== "uph" || !values.uph || values.uph <= 0) return;
    const totalSeconds = Math.round(3600 / values.uph);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    setTime({
      hours: hours.toString().padStart(2, "0"),
      minutes: minutes.toString().padStart(2, "0"),
      seconds: seconds.toString().padStart(2, "0"),
    });
    setValues((prev) => ({
      ...prev,
      proc_time: totalSeconds,
    }));
  }, [values.uph, lastUpdated]);
  useEffect(() => {
    if (lastUpdated !== "time") return;
    const totalSeconds = calculateTotalSeconds();
    if (totalSeconds <= 0) return;
    const calculatedUph = 3600 / totalSeconds;
    const roundedUph = Math.round(calculatedUph * 100) / 100;
    setValues((prev) => ({
      ...prev,
      uph: roundedUph,
      proc_time: totalSeconds,
    }));
  }, [time, lastUpdated]);
  const handleInputChange = (field, value) => {
    if (field === "batch_size") {
      value = Number(value);
      if (value <= 0) value = 1;
    } else if (field === "uph") {
      value = Number(value);
      if (value < 0) value = 0;
      setLastUpdated("uph");
    }
    setValues((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const handleTimeChange = (newTime) => {
    setTime(newTime);
    setLastUpdated("time");
    const totalSeconds =
      Number(newTime.hours || 0) * 3600 +
      Number(newTime.minutes || 0) * 60 +
      Number(newTime.seconds || 0);
    setValues((prev) => ({
      ...prev,
      proc_time: totalSeconds,
    }));
  };
  const handleSave = () => {
    handleUpdateOrder({ values, table, row });
  };
  const handleCancel = () => {
    table.setEditingRow(null);
  };
  return (
    <>
      <DialogTitle
        variant="h5"
        sx={{ fontSize: "18px !important", color: "#111" }}
      >
        공정 수정
      </DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}
      >
        <TextField
          label="공정명"
          value={values.proc_name}
          onChange={(e) => handleInputChange("proc_name", e.target.value)}
          fullWidth
        />
        <TimeInput time={time} setTime={handleTimeChange} />
        <TextField
          label="UPH"
          fullWidth
          type="number"
          inputProps={{ step: "0.01", min: "0" }}
          value={values.uph}
          onChange={(e) => handleInputChange("uph", e.target.value)}
        />
        <TextField
          label="배치사이즈"
          fullWidth
          type="number"
          inputProps={{ min: "1" }}
          value={values.batch_size}
          onChange={(e) => handleInputChange("batch_size", e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSave} variant="contained" color="primary">
          저장
        </Button>
        <Button onClick={handleCancel} variant="outlined">
          취소
        </Button>
      </DialogActions>
    </>
  );
}

export default EditRowDialog;
